import * as ActionCreators from './actionCreators';
import * as Http from '../api/http';
import * as ErrorActions from './errorActions';
import { methodConstants } from '../constants/methodConstants';
import * as CommonActions from './commonActions';
import * as BankAccountActions from './bankAccountActions';
import * as OverviewActions from './overviewActions';
import * as OrderActions from './ordersActions';
import * as OrderSearchActions from './orderSearchActions';
import { getProperties } from './overviewActions';
import { initialManuallyEnteredValues } from '../initializeObjects/bankAccountFilters';
import initPendo from './pendo';

import { 
  selectCompiledSideNav,
  selectCompiledCartLink,
  selectCompiledCatalogLink,
  selectCompiledCatalogPoints,
  selectCompiledNeutralColor,
  selectCompiledPrimaryColor,
  selectCompiledSecondaryColor,
  selectTransformedAwards,
  selectTransformedCatalogs,
  filterSideNav,
  selectTransformedBanks,
  selectFooterLinks,
  selectLogoutLink,
  selectAvatarDetails,
  selectRedeemPrograms

} from '../selectors/layouts';

import {
  selectCompiledAlertsCount,
  selectCompiledGenericAlertsArray,
  selectCompiledReceiveAlertsArray
} from '../selectors/alerts';
import { appConstants } from '../constants/appConstants';

export const closeDisplayMessage = (isDialog) => (dispatch) => {
  if(isDialog){
    dispatch(ActionCreators.isDisplayMessageDialog(false));
  }else{
    dispatch(ActionCreators.displayMessage(false));
  }
};

export const handleNavSelect = (title, url) => (dispatch, getState) => {
  const currentState = getState();
  const sideNavData = currentState.sideNavContent;
  if(sideNavData && sideNavData.submenu){
    if(url){
      let changedUrl = '';
      if((url.indexOf(appConstants.ROUTE_ORDER_DETAILS) !== -1) || 
        (url.indexOf(appConstants.ROUTE_AWARD_DETAILS) !== -1) ||
        (url.indexOf(appConstants.ROUTE_ORDER_SEARCH) !== -1)){
        changedUrl = appConstants.ROUTE_ORDERS;
      }else{
        changedUrl = url;
      }
      const link = changedUrl.split('/');
      const len = link.length;
      const endPoint = link[len - 1];
      filterSideNav(sideNavData.submenu, [CommonActions.replaceAllSpecialChars(endPoint).toLowerCase()], currentState.basePath, true);
    }else if(title){
      filterSideNav(sideNavData.submenu, [CommonActions.replaceAllSpecialChars(title).toLowerCase()], currentState.basePath, true);
    }
    dispatch(ActionCreators.sideNavContent(sideNavData));
  }
};

export const expandSubscriptions = (isExpanded, isSelected) => (dispatch, getState) => {
  if (isSelected) {
    const sideNavData = getState().sideNavContent;
    sideNavData.isSubscriptionsExpanded = !sideNavData.isSubscriptionsExpanded;
    dispatch(ActionCreators.sideNavContent(sideNavData));
  }
};

export const displaySideMenu = (display) => (dispatch, getState) => {
  const sideNavData = getState().sideNavContent;
  sideNavData.sideMenuDisplay = display;
  dispatch(ActionCreators.sideNavContent(sideNavData));
};

export const getLayouts = () => (dispatch, getState) => {
  const currentState = getState();
  let customerLogoUrl = '', activityMenu = '', customerId = '', dateFormat = '', customerSTP = '';
  const layoutUrl = CommonActions.getFullApiUrl(methodConstants.GET_LAYOUT_URL, currentState);
  Http.get(layoutUrl, currentState).then((res) => {
    dispatch(ActionCreators.hasGivenWidgetEnabled(res.hasGiveWidgetEnabled));
    dispatch(ActionCreators.activeLanguage(currentState.locale.replace('-','_')));
    if(CommonActions.isDefined(res.theme)){
      if(CommonActions.isDefined(res.theme.logoUrl)){
        customerLogoUrl = res.theme.logoUrl;
      }
      if(CommonActions.isDefined(res.theme.stp)){
        customerSTP = res.theme.stp;
      }
    }
    if(CommonActions.isDefined(res.customerId)){
      customerId = res.customerId;
    }
    if(CommonActions.isDefined(res.customer.config.dateFormat)){
      dateFormat = res.customer.config.dateFormat;
    }
    dispatch(ActionCreators.customerDateFormat(dateFormat));
    activityMenu = res.activity;
    const sideNavData = selectCompiledSideNav(activityMenu, currentState.basePath);
    const cartLink = selectCompiledCartLink(res);
    // const catalogPoints = selectCompiledCatalogPoints(res);
    const catalogLink = selectCompiledCatalogLink(res);
    const awards = selectTransformedAwards(res);
    const catalogs = selectTransformedCatalogs(res);
    const clientColors = {
      primaryColor: selectCompiledPrimaryColor(res),
      secondaryColor: selectCompiledSecondaryColor(res),
      neutralColor: selectCompiledNeutralColor(res)
    };
    const { systemUserId = '', theme : { stp = '' } = {} } = res;
    CommonActions.initFullStory(systemUserId, stp);
    initPendo(window.pendo, res);
    const banks = selectTransformedBanks(res);
    const catalogPoints = selectCompiledCatalogPoints(res);
    if(catalogPoints ===  0 || catalogPoints ===  '0'){
      dispatch(ActionCreators.catalogPoints(''));
    }else{
      dispatch(ActionCreators.catalogPoints(catalogPoints));
    }
    if(banks.length > 0){
      banks.forEach(bank => {
        if(bank.isCurrentBank){
          //dispatch(ActionCreators.catalogPoints(bank.points));
          if(bank.isPointsBank || res.hasGiveWidgetEnabled){
            dispatch(ActionCreators.catalogSymbol(bank.name));
          }else{
            dispatch(ActionCreators.catalogSymbol(''));
          }
        }
      });
    }
    // else {
    //   dispatch(getCatalogPoints());
    // }
    const footerLinks = selectFooterLinks(res);
    const logout = selectLogoutLink(res);
    dispatch(ActionCreators.logoutValue(logout));
    dispatch(ActionCreators.footerLinks(footerLinks));
    dispatch(ActionCreators.preferredLocale(res.preferredLanguage));
    dispatch(ActionCreators.clientColors(clientColors));
    dispatch(ActionCreators.awards(awards));
    dispatch(ActionCreators.catalogLink(catalogLink));
    dispatch(ActionCreators.cartLink(cartLink));
    dispatch(ActionCreators.customerLogoUrl(customerLogoUrl));
    dispatch(ActionCreators.customerId(customerId));
    dispatch(ActionCreators.customerTitle(res.title));
    dispatch(ActionCreators.activityMenu(activityMenu));
    dispatch(ActionCreators.greeting(res.greeting));
    dispatch(ActionCreators.sideNavContent(sideNavData));
    dispatch(ActionCreators.catalogs(catalogs));
    dispatch(ActionCreators.banksCatalog(banks));
    CommonActions.setSystemUserId(res.systemUserId);
    dispatch(getTasksCount());
    dispatch(ActionCreators.customerSTP(customerSTP));
    const {
      pathname
    } = currentState.routing.locationBeforeTransitions;
    if (pathname.indexOf(appConstants.ROUTE_OVERVIEW) > -1) {
      dispatch(getProperties());
    }
    if(currentState.sideNavContent){
      dispatch(handleNavSelect('', pathname));
    }
    if(customerSTP){
      dispatch(getGreatworkTranslations());
    }
    const redeemedPrograms = selectRedeemPrograms(res);
    dispatch(ActionCreators.redeemPrograms(redeemedPrograms));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};

export function translateArray(data, trans){
  const row = {};
  data.map( (item, i) => {
    row[data[i]] = trans[item];
  });
  return row;
}

export const getGreatworkTranslations = () => (dispatch, getState) => {
  const currentState = getState();
  let customerStp = appConstants.OCTANNER_STP;
  if(currentState.customerSTP){
    customerStp = currentState.customerSTP;
  }
  let translationsUrl = CommonActions.getFullApiUrl(methodConstants.GET_GREATWORK_TRANSLATIONS, currentState);
  translationsUrl = CommonActions.modifyString(translationsUrl, '{:stp}', customerStp);
  Http.get(translationsUrl, currentState).then((res) => {
    const obj = {
      customerLabels: translateArray(appConstants.CUSTOMER_LABELS, res)
    };
    dispatch(ActionCreators.translationsGreatwork(obj));
  }).catch((err) => {
    dispatch(ErrorActions.displayError(err));
  });
};

export const getCatalogPoints = () => (dispatch, getState) => {
  const bankData = [];
  const currentState = getState();
  const bankInfoUrl = CommonActions.getFullApiUrl(methodConstants.GET_BANK_OVERVIEW_INFO, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(bankInfoUrl, currentState, request).then((res) => {
    res.collection.forEach((item) => {
      const row = {};
      row['id'] = item.bankId;
      row['name'] = item.bankName;
      row['bankType'] = item.bankType;
      row['pointsBalance'] = item.pointsBalance;
      row['accessCodesBalance'] = item.accessCodesBalance;
      row['pointsDeposited'] = item.pointsDeposited;
      row['pointsWithdrawn'] = item.pointsWithdrawn;
      if(item.bankType && item.bankType.toLowerCase() === appConstants.POINTS.toLowerCase()){
        row['isPointsBank'] = true;
        row['isAccessCodeBank'] = false;
        row['points'] = CommonActions.numberWithCommas(item.pointsBalance);
        row['symbol'] = 'pts';
      }else if(item.bankType && item.bankType.toLowerCase() === appConstants.ACSCODES.toLowerCase()){
        row['isPointsBank'] = false;
        row['isAccessCodeBank'] = true;
        row['points'] = CommonActions.numberWithCommas(item.accessCodesBalance);
        row['symbol'] = '';
      }
      bankData.push(row);
    });
    dispatch(ActionCreators.banks(bankData));
    // if(bankData.length > 0){
    //   dispatch(ActionCreators.catalogPoints(bankData[0].points));
    //   dispatch(ActionCreators.catalogSymbol(bankData[0].symbol));
    // }
  });

};

export const getBankDetails = () => (dispatch, getState) => {
  const currentState = getState();
  const {
    pathname
  } = currentState.routing.locationBeforeTransitions;
  if(CommonActions.isDefined(currentState.sideNavContent) && CommonActions.isDefined(currentState.sideNavContent.submenu)){
    dispatch(handleNavSelect('', pathname));
  }
  dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
  dispatch(ActionCreators.displayLoader(true));
  const bankData = [];
  const bankInfoUrl = CommonActions.getFullApiUrl(methodConstants.GET_BANK_OVERVIEW_INFO, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(bankInfoUrl, currentState, request).then((res) => {
    dispatch(ActionCreators.displayLoader(false));
    res.collection.forEach((item) => {
      const row = {};
      row['id'] = item.bankId;
      row['name'] = item.bankName;
      row['bankType'] = item.bankType;
      row['pointsBalance'] = item.pointsBalance;
      row['accessCodesBalance'] = item.accessCodesBalance;
      row['pointsDeposited'] = item.pointsDeposited;
      row['pointsWithdrawn'] = item.pointsWithdrawn;
      if(item.bankType && item.bankType.toLowerCase() === appConstants.POINTS.toLowerCase()){
        row['isPointsBank'] = true;
        row['isAccessCodeBank'] = false;
        row['points'] = CommonActions.numberWithCommas(item.pointsBalance);
        row['symbol'] = 'pts';
      }else if(item.bankType && item.bankType.toLowerCase() === appConstants.ACSCODES.toLowerCase()){
        row['isPointsBank'] = false;
        row['isAccessCodeBank'] = true;
        row['points'] = CommonActions.numberWithCommas(item.accessCodesBalance);
        row['symbol'] = '';
      }
      bankData.push(row);
    });
    dispatch(ActionCreators.banks(bankData));
    if(currentState.banks.length === 0)
      dispatch(BankAccountActions.setActiveTab(-1, currentState.bankNameSelected,currentState.activeBankId));
    const isBankViewClicked = currentState.isBankViewClicked;
    if(isBankViewClicked){
      dispatch(ActionCreators.isBankViewClicked(false));
    }else if(bankData.length > 0){
      dispatch(ActionCreators.bankNameSelected((bankData[0].name)));
      dispatch(ActionCreators.activeBankId(bankData[0].id));
      dispatch(BankAccountActions.setActiveTab(-1, bankData[0].name,bankData[0].id));
    }
    dispatch(ActionCreators.selectedDropDownValue('isDownload'));
  }).catch((err) => {
    dispatch(ActionCreators.displayLoader(false));
    dispatch(ErrorActions.displayError(err));
  });

};

export const getPersonalDetails = () => (dispatch, getState) => {
  const personalData = {};
  const currentState = getState();
  const personalInfoUrl = CommonActions.getFullApiUrl(methodConstants.GET_PERSONAL_INFO, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(personalInfoUrl, currentState, request).then((res) => {
    personalData.loginName = res.loginName.value;
    personalData.employeeId = res.employeeId.value;
    personalData.fullName = res.fullName.value;
    personalData.hireDate = CommonActions.getDateGenericFormat(res.hireDate.value);
    dispatch(ActionCreators.personalInfoValues(personalData));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};

export const getAlerts = () => (dispatch, getState) => {
  const currentState = getState();
  const alertsUrl = CommonActions.getFullApiUrl(methodConstants.GET_ALERTS_URL, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(alertsUrl, currentState, request).then((res) => {
    const alertsCount = selectCompiledAlertsCount(res);
    const genericAlerts = selectCompiledGenericAlertsArray(res);
    const receiveAlerts = selectCompiledReceiveAlertsArray(res);
    dispatch(ActionCreators.alertsCount(alertsCount));
    dispatch(ActionCreators.genericAlerts(genericAlerts));
    dispatch(ActionCreators.receiveAlerts(receiveAlerts));
  }).catch(() => {
    //dispatch(ErrorActions.displayError(err));
  });
};

export const customerLogoHome = () => (dispatch, getState) => {
  const pathName = appConstants.ROUTE_LOGO_HOME;
  const currentState = getState();
  // let locale = currentState.preferredLanguage;
  const logoUrl = CommonActions.getFullApiUrl(pathName, currentState);

  // if(!locale){
  //   locale = 'en_US';
  // }
  // logoUrl = logoUrl+'/?locale='+locale+'&showCookieMsg=false';
  window.open(logoUrl, '_self');
  
};

export const setActiveLanguage = (language) => (dispatch) => {
  if(language){
    // CommonActions.setCookie(appConstants.KEY_LANGUAGE, language);
    dispatch(ActionCreators.locale(language));
    dispatch(ActionCreators.activeLanguage(language));
  }
};

export const getActiveLanguage = () => (dispatch, getState) => {
  const currentState = getState();
  const locale = currentState.activeLanguage;
  const personalInfoUrl = CommonActions.getFullApiUrl(methodConstants.GET_PERSONAL_INFO, currentState);
  const req = {
    'preferredLanguageLocale': locale
  };
  Http.put(personalInfoUrl, currentState, req).then(() => {
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};

export const displaySideBarPanel = (display) => (dispatch) => {
  dispatch(ActionCreators.isDisplaySideBarPanel(!display));
  CommonActions.setBodyScroll(!display);
};

export function refreshVictoriesHeader(lang) {
  const existingHeader = document.getElementById('victoriesHeader');
  if (existingHeader && existingHeader.parentElement) {
    existingHeader.parentElement.removeChild(existingHeader);
    const victoriesHeader = document.createElement('div');
    victoriesHeader.id = 'victoriesHeader';
    document.querySelector('body header').insertAdjacentElement('beforeend', victoriesHeader);
    // eslint-disable-next-line
    new VictoriesHeader.Create('body header #victoriesHeader', { language: lang.replace(/_/g, '-') });
  }
}

function loadVictoriesHeader(headerBasePath, lang) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = `${headerBasePath}/app.bundle.css`;
  document.head.appendChild(link);
  const script = document.createElement('script');
  script.src = `${headerBasePath}/app.bundle.js`;
  const victoriesHeader = document.createElement('div');
  victoriesHeader.id = 'victoriesHeader';
  document.querySelector('body header').insertAdjacentElement('beforeend', victoriesHeader);
  document.head.appendChild(script);
  script.onload = () => {
    // eslint-disable-next-line
    new VictoriesHeader.Create('body header #victoriesHeader', { language: lang })
  };
}

export const initializeVictoriesHeader = () => (dispatch, getState) => {
  const { victoriesHeaderPath = '', locale = '' } = getState();
  loadVictoriesHeader(victoriesHeaderPath, locale);
};

export const getAvatar = () => (dispatch, getState) => {
  const currentState = getState();
  const personalData = {};
  const alertsUrl = CommonActions.getFullApiUrl(methodConstants.GET_AVATAR_URL, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(alertsUrl, currentState, request).then((res) => {
    const avatar = selectAvatarDetails(res);
    let url = '';
    if(avatar){
      if(avatar.thumb){
        url = avatar.thumb.src;
      }else if(avatar.profile){
        url = avatar.profile.src;
      }else if(avatar.original){
        url = avatar.original.src;
      }
    }
    dispatch(ActionCreators.avatarLink(url));
    personalData.employeeId = res.employeeId;
    personalData.fullName = res.fullName ? res.fullName : res.preferName;
    personalData.hireDate = CommonActions.getDateGenericFormat(res.hireDate);
    personalData.userId = res.id; 
    personalData.name= res.name; 
    dispatch(ActionCreators.personalInfoValues(personalData));
  }).catch((err) => {
    dispatch(ErrorActions.displayError(err));
  });
};

export const getTasksCount = () => (dispatch, getState) => {
  const currentState = getState();
  const tasksUrl = CommonActions.getFullApiUrl(methodConstants.GET_TASKS_COUNT, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(tasksUrl, currentState, request).then((res) => {
    const tasksCount = res.currentTasksCount;
    dispatch(ActionCreators.tasksCount(tasksCount));
  }).catch((err) => {
    dispatch(ErrorActions.displayError(err));
  });
};

export const openPageDropdown = (isOpen) => (dispatch) => {
  dispatch(ActionCreators.pageDropdownOpen(!isOpen));
};

export const handleDisplayForDropDowns = () => (dispatch, getState) => {
  const displayMessage = getState().displayMessage;
  const isDisplayBankDialogActions = getState().isDisplayBankDialogActions;
  const isDisplayProgramDialogActions = getState().isDisplayProgramDialogActions;
  const isDisplayeCardDialogActions = getState().isDisplayeCardDialogActions;
  const isDisplayNominationDialogActions = getState().isDisplayNominationDialogActions;
  const programsDropdownOpen = getState().programsDropdownOpen;
  const downloadDropdownOpen = getState().downloadDropdownOpen;
  const isRangeDropdownOpen = getState().isRangeDropdownOpen;
  const pageDropdownOpen = getState().pageDropdownOpen;
  const isDisplayFromDateCalendar = getState().isDisplayFromDateCalendar;
  const isDisplayToDateCalendar = getState().isDisplayToDateCalendar;
  if(isDisplayBankDialogActions){
    dispatch(BankAccountActions.displayBankActions(false));
  }else if(isDisplayProgramDialogActions){
    dispatch(BankAccountActions.displayProgramActions(false));
  }else if(isDisplayeCardDialogActions){
    dispatch(OverviewActions.displayeCardActions(false));
  }else if(isDisplayNominationDialogActions){
    dispatch(OverviewActions.displayNominationActions(false));
  }else if(downloadDropdownOpen){
    dispatch(BankAccountActions.openDownloadDropdown(true));
  }else if(programsDropdownOpen){
    dispatch(OrderActions.openProgramsDropdown(true));
  }else if(isRangeDropdownOpen){
    dispatch(OrderSearchActions.openRangeDropdown(false));
  }else if(pageDropdownOpen){
    dispatch(openPageDropdown(true));
  }else if(displayMessage){
    dispatch(closeDisplayMessage(false));
  }else if(isDisplayFromDateCalendar){
    dispatch(BankAccountActions.setDateCalendar('', false));
    dispatch(OrderActions.setDateCalendar('', false));
  }else if(isDisplayToDateCalendar){
    dispatch(BankAccountActions.setDateCalendar('', false));
    dispatch(OrderActions.setDateCalendar('', false));
  }
};

export const handleHistoryDialog = () => (dispatch, getState) => {
  const historyReceived = getState().overviewHistoryReceived;
  const historySent = getState().overviewHistorySent;
  let index = -1;
  if(historyReceived && historyReceived.actions.length > 0){
    historyReceived.actions.forEach((action, i) => {
      if(action.displayContainer){
        index = i;
      }
    });
  }
  if(index !== -1){
    dispatch(OverviewActions.displayReceivedActions(false, index));
  }else{
    if(CommonActions.isDefined(historySent) && CommonActions.isDefined(historySent.actions)){
      historySent.actions.forEach((action, i) => {
        if(action.displayContainer){
          index = i;
        }
      });
    }
    if(index !== -1){
      dispatch(OverviewActions.displayGivenActions(false, index));
    }
  }
};

export const displayDialog = (path) => (dispatch) => {
  dispatch(handleDisplayForDropDowns());
  if(path.includes(appConstants.ROUTE_OVERVIEW)){
    dispatch(handleHistoryDialog());
  }
};

function isDisplayCommon(path) {
  const arrIndex = CommonActions.getArrayIndex(appConstants.ROUTING_PATHS, path);

  if (arrIndex !== -1) {
    return true;
  } else if(path.includes(appConstants.ROUTE_ORDER_DETAILS+'/') || path.includes(appConstants.ROUTE_AWARD_DETAILS+'/')){
    return true;
  } else {
    return false;
  }
}

export const displayCommonHeaderSideMenu = () => (dispatch, getState) => {
  const currentState = getState();

  const transition = currentState.routing.locationBeforeTransitions;
  let transitionPath = '';
  if (CommonActions.checkObjectLength(transition)) {
    transitionPath = transition.pathname;
  }
  const blnDisplaySideMenu = isDisplayCommon(transitionPath);
  dispatch(ActionCreators.isDisplayCommonHeaderSideMenu(blnDisplaySideMenu));
  dispatch(ActionCreators.displayLoader(blnDisplaySideMenu));
  CommonActions.setDateDisplayTimeZone(currentState.dateDisplayTimezone);
};

export const getRecieveAlert = (endPoint) => (dispatch, getState) => {
  const currentState = getState();
  if(endPoint && endPoint.includes('.seam')){
    let alertAPI = CommonActions.getLegacyRootUrl(currentState.environment);
    alertAPI+=endPoint;
    window.open(alertAPI);
  }else if(endPoint){
    let basePath = '';
    if(currentState.basePath){
      basePath = currentState.basePath;
    }
    basePath = basePath.replace('/ui/accounts', '');
    let alertAPI = basePath;
    alertAPI+=endPoint;
    window.open(alertAPI, '_self');
  }
};
